import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Menu,
  Dropdown,
} from "antd";
//import { ReportsTable5 } from "./Tables/Table5";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { Document5 } from "./ReportDocuments/Document_5";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext";
import moment from "moment";
import { roleAction } from "../../_actions/roleby.action";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const ReportsTable5 = React.lazy(() =>
  import("./Tables/Table5").then((module) => ({
    default: module.ReportsTable5,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class Reports5 extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }

  state = {
    loading: false,
    downloadLoding: false,
    report5_List: [],
    report5_List_Total: null,
    report5_API_loader: false,
    totalAppUser: 0,
    totalAppInactiveUser: 0,
    download: "excel",
  };

  componentDidMount() {
    this.generatePDFReport1();
  }

  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.totalAppUsers;

    return (
      arrData1?.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("police_station")]: data?.districtName || "-",
        [t("total_app_user")]: data?.cnt || 0,
      })) || []
    );
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("total_app_user");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReports = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };

  downloadReport = async () => {
    const { user } = this.props;
    let obj = {
      cityId: user && user.cityId,
    };
    this.setState({
      report1_loader: true,
    });
    const blob = await pdf(
      <Document5
        rows={this.state.totalAppUsers}
        filterDate={obj}
        total={this.state.report5_List_Total}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report1_loader: false,
      });
      saveAs(blob, "एकूण अ‍ॅप वापरकर्ते");
    }
  };

  download_csv = () => {
    const { t } = this.context;

    const ReportTitle = t("total_app_user");
    const title = t("total_app_user");
    const arrData1 = this.state.totalAppUsers || [];

    // 🔒 SAFETY: no data
    if (!arrData1.length) {
      message.warning(t("no_data_available"));
      return;
    }

    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;

    const arrData = arrData1.map((data, index) => ({
      [t("sr.no")]: index + 1,
      [t("police_station")]: data?.districtName || "-",
      [t("total_app_user")]: data?.cnt || 0,
    }));

    // ===================== STYLES =====================
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // ===================== WORKBOOK =====================
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];

    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;

    const cityName = this.getCityName(this.props?.user?.cityId || "");
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;

    const headerData =
      this.props?.user?.role === "2" ? `${stateName} (${cityName})` : cityName;

    // ===================== TITLE =====================
    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    if (ws["A1"]) ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    if (ws["A2"]) ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    // ===================== HEADERS =====================
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });

    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    // ===================== DATA =====================
    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    // ===================== FOOTER =====================
    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    const footerCell = `A${footerRowIndex}`;
    if (ws[footerCell]) {
      ws[footerCell].s = {
        font: { italic: true, sz: 11, color: { rgb: "555555" } },
        alignment: { horizontal: "center" },
      };
    }

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    // ===================== FORMATTING =====================
    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(key.length, ...arrData.map((row) => String(row[key]).length)) +
        6,
    }));

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];

    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }

    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };

    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    // ===================== EXPORT =====================
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    this.setState({
      report5_API_loader: true,
    });
    console.log(user.role);
    let role = user && user.role;
    let cityId = user && user.cityId;

    if (role && role === "4") {
      professionalAction.getTotalAppUsersCount(role, cityId).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData && tempData.data && _.flatten(tempData.data),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            const result = Object.values(tempData.result).reduce(
              (r, { cnt }) => r + cnt,
              0,
            );
            this.setState({
              report5_API_loader: false,
              report5_List: tempFilterData,
              totalAppUsers: tempData && tempData.result,
              report5_List_Total: result,
              totalAppUser: tempData && tempData.totalAppUser,
              totalAppInactiveUser: tempData && tempData.totalAppInactiveUser,
            });
          });
      });
    }
    if (role === "9" || role === "10") {
      let obj = {
        districtId: user && user.map_districtId,
      };
      roleAction.TotalAppUsersCountByRole(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData && tempData.data && _.flatten(tempData.data),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            const result = Object.values(tempData.result).reduce(
              (r, { cnt }) => r + cnt,
              0,
            );
            this.setState({
              report5_API_loader: false,
              report5_List: tempFilterData,
              totalAppUsers: tempData && tempData.result,
              report5_List_Total: result,
              totalAppUser: tempData && tempData.totalAppUser,
              totalAppInactiveUser: tempData && tempData.totalAppInactiveUser,
            });
          });
      });
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report5_List } = this.state;

    const sortedData = [...report5_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report5_List: sortedData });
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading } = professionals;
    const { language, t } = this.context;
    console.log(this.state.totalAppUsers);
    const { key, direction } = this.state;

    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        <Menu.Item key="cnt">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            एकूण अ‍ॅप वापरकर्ते
            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "cnt" && direction === "ASC" ? "#1890ff" : "#bfbfbf",
              }}
              onClick={() => this.sortby("cnt", "ASC")} // Toggle to ASC
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "cnt" && direction === "DESC" ? "#1890ff" : "#bfbfbf",
              }}
              onClick={() => this.sortby("cnt", "DESC")} // Toggle to DESC
            />
          </div>
        </Menu.Item>
      </Menu>
    );
    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={user && user.userid}
              subTitle={
                user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
              }
            ></PageHeader>

            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={t("total_app_user")}
              extra={[
                <>
                  <Form>
                    <Form.Item
                      name="condition"
                      rules={[
                        {
                          required: true,
                          message: "Please select a value",
                        },
                      ]}
                      style={{ marginBottom: 0 }}
                    >
                      <Select
                        placeholder={t("please_select_an_option")}
                        value={this.state.download}
                        onChange={(value) => this.setState({ download: value })}
                        style={{ width: 150 }}
                        disabled={!this.state.totalAppUsers}
                      >
                        <Option key="excel" value="excel">
                          {t("excel")}
                        </Option>
                        <Option key="pdf" value="pdf">
                          PDF
                        </Option>
                      </Select>
                    </Form.Item>
                  </Form>

                  {this.state.download && (
                    <Button
                      key="1"
                      type="primary"
                      style={{ minWidth: 120 }}
                      onClick={() => this.downloadReports()}
                    >
                      Download
                    </Button>
                  )}
                  <Dropdown
                    overlay={menu}
                    placement="bottomRight"
                    arrow
                    disabled={!this.state.report5_List?.length}
                  >
                    <Button type="ghost">
                      {t("sorter_by")} <DownOutlined />
                    </Button>
                  </Dropdown>
                </>,
              ]}
            ></PageHeader>

            <React.Suspense fallback={<div>Loading...</div>}>
              <ReportsTable5
                data={this.state.totalAppUsers}
                total={this.state.report5_List_Total}
                totalAppUser={this.state.totalAppUser}
                totalAppInactiveUser={this.state.totalAppInactiveUser}
                loading={this.state.report5_API_loader}
              ></ReportsTable5>
            </React.Suspense>
          </div>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports5 = connect(mapStateToProps)(Reports5);
export { connectedReports5 as Reports5 };
